module.exports = __webpack_public_path__ + "static/media/Cabins.44faa3ae.svg";